import * as React from "react";
import Grid from "@mui/material/Grid";
import {
  Radio,
  RadioGroup,
  TextField,
  FormControl,
  FormControlLabel,
  FormLabel,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

import {
  AppraisalReviewServiceURL,
  InvestmentServiceURL,
  TaskmgmtServiceURL,
} from "../../../config/config";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
// import { constants } from "buffer";
import { ServiceName } from "../../../constants";
import { useEffect, useState, ChangeEvent } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { CurrentUser } from "../../../redux/slices/currentUserSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { useForm, Controller, FieldValues } from "react-hook-form";
import { InvestmentNames } from "../../../redux/slices/selectedInvestmentForAppraisalslice";
import { UserContext } from "../../../redux/slices/userContextSlice";
import { InvestmentAppraisalValuesForm } from "./InvestmentAppraisalValuesForm";
import { InvestmentAssetValuesTableForm } from "./InvestmentAssetValuesTableForm";
import { getInvestmentMaster } from "../../../redux/slices/AddUpdateInvestmentMasterSlice";
import { getAllApplicationUser } from "../../../redux/slices/GetAllApplicationUserSlice";
import { getAllFunds } from "../../../redux/slices/GetAllFundsForInvestmentMasterSlice";
import {
  ApplicationUser,
  Asset,
  Funds,
  InvestmentMasterAppraisalValue,
  InvestmentMasterModel,
} from "../../../all_Interfaces";
import { wait } from "@testing-library/user-event/dist/utils";
import { ToastMessage } from "../../util/ToastMessage";
import { UserDetails } from "../../../layout/UserDetails";
import dayjs from "dayjs";
import { updateInvestmentAsset } from "../../../redux/slices/InvestmentMasterAssetSlice";
import { updateInvestmentAppraisal } from "../../../redux/slices/UpdateInvestmentMasterAppraisalValueSlice";
import { log } from "console";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

type Fund = {
  label: string;
  fundId: string;
  fundName: string;
};

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export const InvestmentEditDisplayForm = () => {
  const navigate = useNavigate();
  const params = useParams();
  const page = params.page;
  const invId = params.investmentId;

  const dispatch = useAppDispatch();
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  // const [expanded, setExpanded] = React.useState<string | false>("panel1");
  const assets: Asset[] = useAppSelector(
    (state) => state.UpdateInvestmentAsset.data
  );
  const investmentAppraisalValue: InvestmentMasterAppraisalValue =
    useAppSelector((state) => state.UpdateInvestmentMasterAppraisal.data);
  const [fundList, setFundList] = useState<
    { label: string; fundId: string; fundName: string }[]
  >([]);

  const [fgInvestmentAppraisalValuesRDX, setFgInvestmentAppraisalValuesRDX] =
    useState<InvestmentMasterAppraisalValue>({
      lastAppraisedValue: 0,
      lastAnnualAppraisedValue: 0,
      nextAppraisalDate: "",
      appraisalStatus: "",
      lastAppraisalDate: "",
      lastAnnualAppraisalDate: "",
      lastAppraisalType: "",
      lastDLAppraisedValue: 0,
      lastDLAnnualAppraisedValue: 0,
      lastDLAppraisalDate: "",
      lastDLAnnualAppraisalDate: "",
    });
  const [assetsRDX, setAssetsRDX] = useState<Asset[]>([]);
  const [userList, setUserList] = useState<
    ({ label: string; user: ApplicationUser } | undefined)[]
  >([]);
  // const handleChange =
  //   (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
  //     setExpanded(newExpanded ? panel : false);
  //   };
  const [validators, setValidators] = useState<
    { label: string; isEmpty: boolean; valid: boolean }[]
  >([
    { label: "Fund", isEmpty: true, valid: false },
    { label: "InvestmentName", isEmpty: true, valid: false },
    { label: "InvestmentType", isEmpty: true, valid: false },
    { label: "PropertyType", isEmpty: true, valid: false },
    { label: "AssetManager", isEmpty: true, valid: false },
    { label: "InvestmentStatus", isEmpty: true, valid: false },
    // { label: "Assets", isEmpty: true,valid:false },
  ]);
  const [loading, setLoading] = useState<boolean>(false);
  const currentUserData: CurrentUser = useAppSelector(
    (state) => state.currentUser.data
  );
  const userLoad = useAppSelector(
    (state) => state.GetAllApplicationUsers.loading
  );
  const fundLoad = useAppSelector(
    (state) => state.GetAllFundsForInvestment.loading
  );
  const allApplicationUser: ApplicationUser[] = useAppSelector(
    (state) => state.GetAllApplicationUsers.data
  );
  const allFunds: Funds[] = useAppSelector(
    (state) => state.GetAllFundsForInvestment.data
  );
  const [investmentType, setInvestmentType] = useState<string>();
  const [isSuccess, setIsSuccess] = useState<{
    isSuccess: boolean;
    message: string;
  }>({ isSuccess: false, message: "" });
  const [isError, setIsError] = useState<{ isError: boolean; message: string }>(
    { isError: false, message: "" }
  );
  const [investment, setInvestment] = useState<InvestmentMasterModel>({
    id: "",
    investmentId: "",
    name: "",
    fundId: "",
    fund: "",
    assetManager: {
      firstName: "",
      lastName: "",
      email: "",
    },
    assetManagerName: "",
    investmentType: "",
    propertyType: "",
    city: "",
    state: "",
    country: "",
    hasDebtLiability: false,
    lastAnnualAppraisedValue: 0,
    status: "",
    portfolioManager: {
      firstName: "",
      lastName: "",
      email: "",
    },
    asstPortfolioManager: {
      firstName: "",
      lastName: "",
      email: "",
    },
    assetManagerHead: {
      firstName: "",
      lastName: "",
      email: "",
    },
    sectorHead: {
      firstName: "",
      lastName: "",
      email: "",
    },
    xmin: 0,
    createdBy: "",
    created: "",
    lastModifiedBy: "",
    lastModified: "",
    lastSyncedOn: "",
    fgInvestmentAppraisalValues: {
      lastAppraisedValue: 0,
      lastAnnualAppraisedValue: 0,
      nextAppraisalDate: "",
      appraisalStatus: "",
      lastAppraisalDate: "",
      lastAnnualAppraisalDate: "",
      lastAppraisalType: "",
      lastDLAppraisedValue: 0,
      lastDLAnnualAppraisedValue: 0,
      lastDLAppraisalDate: "",
      lastDLAnnualAppraisalDate: "",
    },
    assets: [],
  });

  console.log("Assets from asset table >>> ", assets);
  console.log("appraisal values >>>> ", investmentAppraisalValue);

  useEffect(() => {
    dispatch(getAllApplicationUser());
    dispatch(getAllFunds());
  }, []);

  useEffect(() => {
    fetchInvestment();
  }, []);

  useEffect(() => {
    setFgInvestmentAppraisalValuesRDX(investmentAppraisalValue);
  }, [investmentAppraisalValue]);

  useEffect(() => {
    setAssetsRDX(assets);
  }, [assets]);

  const fetchInvestment = async () => {
    await getApiCall<any>(
      InvestmentServiceURL + "/investments/getbyId?id=" + invId,
      ServiceName.INVESTMENTSERVICE
    ).then((data: any) => {
      console.log(data);
      var inv: InvestmentMasterModel = data?.result;
      setInvestment(inv);

      validators.map((obj, i) => {
        switch (obj.label) {
          case "Fund":
            validators[i].isEmpty =
              inv.fund != "" && inv.fundId != "" ? false : true;
            validators[i].valid = inv.fund != "" && inv.fundId != "";
            break;
          case "InvestmentName":
            validators[i].isEmpty = inv.name != "" ? false : true;
            validators[i].valid = inv.name != "";
            break;
          case "InvestmentType":
            validators[i].valid = inv.investmentType != "";
            validators[i].isEmpty = inv.investmentType != "" ? false : true;
            break;
          case "PropertyType":
            validators[i].isEmpty = inv.propertyType != "" ? false : true;
            validators[i].valid = inv.propertyType != "";
            break;
          case "AssetManager":
            validators[i].isEmpty = inv.assetManager != null ? false : true;
            validators[i].valid = inv.assetManager != null;
            break;
          case "InvestmentStatus":
            validators[i].isEmpty = inv.status != "" ? false : true;
            validators[i].valid = inv.status != "";
            break;
        }
      });

      dispatch(updateInvestmentAsset(data?.result.assets));
      dispatch(
        updateInvestmentAppraisal(data?.result.fgInvestmentAppraisalValues)
      );
    });
  };
  console.log(investment);
  // useEffect(() => {
  //   if(Object.keys(userContext).length === 0){

  //   }
  // }, []);
  //   useEffect(() => {

  //   }, []);

  useEffect(() => {
    if (Array.isArray(allFunds) && Array.isArray(allApplicationUser)) {
      var USFunds: Funds[] = allFunds.filter((f) => f.region === "US");
      setFundList(
        USFunds.map((fund: Funds) => {
          return {
            label: fund.fundID + ": " + fund.fundName,
            fundId: fund.fundID,
            fundName: fund.fundName,
          };
        })
      );

      var userArr: { label: string; user: ApplicationUser }[] = [];
      userArr = allApplicationUser.map((user: ApplicationUser, index: any) => {
        return {
          label: user.firstName + " " + user.lastName,
          user: user,
        };
      });
      const uniqueOptions = Array.from(
        new Set(userArr.map((a) => a.label))
      ).map((label) => {
        return userArr.find((a) => a.label === label);
      });
      setUserList(uniqueOptions);
    }
  }, [allApplicationUser, allFunds]);
  const investmentTypeList = ["Equity", "Debt Asset", "Mortgage"];
  const investmentStatusList = [
    "New",
    "Pending Acquisition",
    "Active",
    "Dead Deal",
    "Retired/Sold",
    "Sold-Inactive",
  ];
  const { control, handleSubmit } = useForm({});

  const handleInvestmentStatusChange = (value: string) => {
    setValidators(
      validators.map((obj) =>
        obj.label === "InvestmentStatus"
          ? { ...obj, valid: value != "", isEmpty: value != "" ? false : true }
          : { ...obj }
      )
    );
    setInvestment({ ...investment, status: value });
  };

  const handleInvestmentTypeChange = (type: string) => {
    setValidators(
      validators.map((obj) =>
        obj.label === "InvestmentType"
          ? {
            ...obj,
            valid: type != "",
            isEmpty: type != "" ? false : true,
          }
          : { ...obj }
      )
    );
    if (type != null) {
      setInvestment({ ...investment, investmentType: type });
    }
    // setInvestmentType(type);
  };
  const handleHasDebtLiabilityChange = (
    event: ChangeEvent<HTMLInputElement>,
    value: string
  ): void => {
    setInvestment({
      ...investment,
      hasDebtLiability: value === "Yes" ? true : false,
    });
  };
  const handleFundChange = (value: any) => {
    setValidators(
      validators.map((obj) =>
        obj.label === "Fund"
          ? {
            ...obj,
            isEmpty: value != null ? false : true,
            valid: value != null,
          }
          : { ...obj }
      )
    );
    if (value != null) {
      setInvestment({
        ...investment,
        fund: value.fundName,
        fundId: value.fundId,
      });
    } else {
      setInvestment({
        ...investment,
        fund: "",
        fundId: "",
      });
    }
  };

  // const handleInvestmentIdChange = (id: string) => {
  //   setValidators(
  //     validators.map((obj) =>
  //       obj.label === "InvestmentID"
  //         ? { ...obj, isEmpty: id != "" ? false : true, valid: id != "" }
  //         : { ...obj }
  //     )
  //   );
  //   setInvestment({ ...investment, investmentId: id });
  // };
  const handleInvestmentNameChange = (name: string) => {
    setValidators(
      validators.map((obj) =>
        obj.label === "InvestmentName"
          ? { ...obj, isEmpty: name != "" ? false : true, valid: name != "" }
          : { ...obj }
      )
    );
    setInvestment({ ...investment, name: name });
  };

  const handlePropertyTypeChange = (propType: string) => {
    setValidators(
      validators.map((obj) =>
        obj.label === "PropertyType"
          ? {
            ...obj,
            isEmpty: propType != "" ? false : true,
            valid: propType != "",
          }
          : { ...obj }
      )
    );
    setInvestment({ ...investment, propertyType: propType });
  };
  const handleAssetManagerChange = (value: any) => {
    setValidators(
      validators.map((obj) =>
        obj.label === "AssetManager"
          ? {
            ...obj,
            isEmpty: value != null ? false : true,
            valid: value != null,
          }
          : { ...obj }
      )
    );
    if (value != null) {
      setInvestment({
        ...investment,
        assetManager: {
          firstName: value.user.firstName,
          lastName: value.user.lastName,
          email: value.user.email,
        },
      });
    } else {
      setInvestment({
        ...investment,
        assetManager: {
          firstName: "",
          lastName: "",
          email: "",
        },
      });
    }
  };
  const handleAssetManagerHeadChange = (value: any) => {
    if (value != null) {
      setInvestment({
        ...investment,
        assetManagerHead: {
          firstName: value.user.firstName,
          lastName: value.user.lastName,
          email: value.user.email,
        },
      });
    } else {
      setInvestment({
        ...investment,
        assetManagerHead: {
          firstName: "",
          lastName: "",
          email: "",
        },
      });
    }
  };
  const handleSectorHeadChange = (value: any) => {
    if (value != null) {
      setInvestment({
        ...investment,
        sectorHead: {
          firstName: value.user.firstName,
          lastName: value.user.lastName,
          email: value.user.email,
        },
      });
    } else {
      setInvestment({
        ...investment,
        sectorHead: {
          firstName: "",
          lastName: "",
          email: "",
        },
      });
    }
  };
  const handlePortfilioManagerChange = (value: any) => {
    if (value != null) {
      setInvestment({
        ...investment,
        portfolioManager: {
          firstName: value.user.firstName,
          lastName: value.user.lastName,
          email: value.user.email,
        },
      });
    } else {
      setInvestment({
        ...investment,
        portfolioManager: {
          firstName: "",
          lastName: "",
          email: "",
        },
      });
    }
  };

  const handleAssetPortfilioManagerChange = (value: any) => {
    if (value != null) {
      setInvestment({
        ...investment,
        asstPortfolioManager: {
          firstName: value.user.firstName,
          lastName: value.user.lastName,
          email: value.user.email,
        },
      });
    } else {
      setInvestment({
        ...investment,
        asstPortfolioManager: {
          firstName: "",
          lastName: "",
          email: "",
        },
      });
    }
  };
  const handleCityChange = (city: string) => {
    setInvestment({ ...investment, city: city });
  };
  const handleStateChange = (state: string) => {
    setInvestment({ ...investment, state: state });
  };
  const handleCountryChange = (country: string) => {
    setInvestment({ ...investment, country: country });
  };

  const submitInvestment = async () => {
    console.log(validators);

    var v = validators.filter((e) => e.valid != true);
    var e = validators.filter((e) => e.isEmpty != false);

    var invalidAssets: Asset[] = Array.isArray(assetsRDX)
      ? assetsRDX.filter(
        (asset) => asset.id === "" || asset.name === "" || asset.status === ""
      )
      : [];

    console.log(v, e);

    setIsSubmit(true);
    console.log(currentUserData);
    var currentDate = dayjs();
    var currDate = currentDate.format("MM-DD-YYYY HH:mm:ss");
    var currUserEmail =
      currentUserData.email != undefined ? currentUserData.email : "";
    var assetList: Asset[] = assetsRDX.map((a: Asset) => {
      return {
        ...a,
        investmentId: investment.investmentId,
        createdBy:
          currentUserData.name != undefined ? currentUserData.name : "",
        lastModifiedBy:
          currentUserData.name != undefined ? currentUserData.name : "",
        created: currDate,
        lastModified: currDate,
      };
    });

    if (v.length === 0 && e.length === 0 && invalidAssets.length === 0) {
      var dbInvestment: InvestmentMasterModel = {
        ...investment,
        fgInvestmentAppraisalValues: fgInvestmentAppraisalValuesRDX,
        assets: assetList,
        lastModified: currDate,
        lastModifiedBy: currUserEmail,
      };

      console.log(assetList);
      console.log(investment);
      try {
        setLoading(true);
        await postApiCall(
          InvestmentServiceURL + "/investments/Update",
          dbInvestment,
          ServiceName.INVESTMENTSERVICE
        )
          .then((res: any) => {
            setIsSuccess({
              isSuccess: true,
              message: "Investment is submitted",
            });
            wait(4001).then(() => {
              navigate("/investmentmaster/list");
            });
          })
          .catch((error: any) => {
            console.log(error);
            setIsError({
              isError: true,
              message: error.response.data.responseException.exceptionMessage,
            });
          });
      } catch (error) {
        console.log(error);
      } finally {
        wait(1000).then(() => {
          dispatch(
            updateInvestmentAppraisal({} as InvestmentMasterAppraisalValue)
          );
          dispatch(updateInvestmentAsset([] as Asset[]));
          setLoading(false);
        });
      }
    } else {
      setIsError({ isError: true, message: "Clear the validation errors" });
      wait(3000).then(() => {
        setIsError({ isError: false, message: "" });
      });
    }
  };
  console.log(investment);
  return (
    <div className="form-wrap">
      <Box sx={{ width: "100%", typography: "body1" }}>
        {(userLoad || fundLoad) && (
          <div className="overlaySpinner">
            <CircularProgress />
          </div>
        )}

        {loading && (
          <div className="overlaySpinner">
            <CircularProgress />
          </div>
        )}

        {isSuccess.isSuccess && (
          <ToastMessage message={isSuccess.message} severity="success" />
        )}
        {isError.isError && (
          <ToastMessage message={isError.message} severity="error" />
        )}
        <h3 className="heading">Investment Values :</h3>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6}>
            <Controller
              name="fundName"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="fund-id"
                  readOnly={page === "view"}
                  options={fundList}
                  value={{
                    label: investment.fundId + ": " + investment.fund,
                    fundId: investment.fundId,
                    fundName: investment.fund,
                  }}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleFundChange(value);
                  }}
                  // sx={{ width: 400 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Fund"
                      size="small"
                      required
                      InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                      error={
                        isSubmit &&
                        (investment.fund === "" || investment.fundId === "")
                      }
                    />
                  )}
                />
              )}
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <Controller
              name="InvestmentID"
              control={control}
              render={({ field }) => (
                <TextField
                  className="Autopopulatefield"
                  value={investment.investmentId}
                  label="Investment ID"
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="InvestmentName"
              control={control}
              render={({ field }) => (
                <TextField
                  required
                      InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                  InputProps={{
                    readOnly: page === "view",
                  }}
                  value={investment?.name || ""}
                  onChange={(e) => handleInvestmentNameChange(e.target.value)}
                  label="Investment Name"
                  variant="outlined"
                  size="small"
                  error={isSubmit && investment.name === ""}
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="investmentType"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="investmentType-id"
                  readOnly={page === "view"}
                  value={investment.investmentType}
                  options={investmentTypeList}
                  // sx={{ width: 400 }}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleInvestmentTypeChange(value === null ? "" : value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Investment Type"
                      size="small"
                      required
                      InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                      error={isSubmit && investment.investmentType === ""}
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="PropertyType"
              control={control}
              render={({ field }) => (
                <TextField
                  required
                      InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                  InputProps={{
                    readOnly: page === "view",
                  }}
                  value={investment.propertyType}
                  onChange={(e) => handlePropertyTypeChange(e.target.value)}
                  label="Property Type"
                  variant="outlined"
                  size="small"
                  error={isSubmit && investment.propertyType === ""}
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="LastModifiedDate"
              control={control}
              render={({ field }) => (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      name="LastModified"
                      format="MMM-DD-YYYY"
                      className="Autopopulatefield"
                      value={
                        investment.lastModified === "" ||
                          investment.lastModified == null
                          ? null
                          : dayjs(investment.lastModified, "MM-DD-YYYY")
                      }
                      views={["month", "day", "year"]}
                      //   sx={{ width: 300 }}
                      readOnly={true}
                      slotProps={{ textField: { size: "small" } }}
                      label="Last Modified Date"
                    />
                  </DemoContainer>
                </LocalizationProvider>
              )}
            />
          </Grid >
          <Grid item xs={6} sm={6}>
            <Controller
              name="LastSyncedOn"
              control={control}
              render={({ field }) => (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      name="LastSyncedOn"
                      format="MMM-DD-YYYY"
                      className="Autopopulatefield"
                      value={
                        investment.lastSyncedOn === "" ||
                          investment.lastSyncedOn == null
                          ? null
                          : dayjs(investment.lastSyncedOn, "MM-DD-YYYY")
                      }
                      views={["month", "day", "year"]}
                      //   sx={{ width: 300 }}
                      readOnly={true}
                      slotProps={{ textField: { size: "small" } }}
                      label="Last Synced On"
                    />
                  </DemoContainer>
                </LocalizationProvider>
              )}
            />
          </Grid >
          <Grid item xs={6} sm={6}>
            <Controller
              name="AssetManager"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="AssetManager-id"
                  options={userList}
                  readOnly={page === "view"}
                  value={
                    investment.assetManager != null
                      ? {
                        label:
                          investment.assetManager.firstName +
                          " " +
                          investment.assetManager.lastName,
                        user: investment.assetManager,
                      }
                      : {
                        label: "",
                        user: investment.assetManager,
                      }
                  }
                  // sx={{ width: 400 }}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleAssetManagerChange(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Asset Manager"
                      size="small"
                      error={isSubmit && investment.assetManager.email === ""}
                      required
                      InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="AssetManagerHead"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="AssetManagerHead-id"
                  options={userList}
                  readOnly={page === "view"}
                  value={
                    investment.assetManagerHead != null
                      ? {
                        label:
                          investment.assetManagerHead.firstName +
                          " " +
                          investment.assetManagerHead.lastName,
                        user: investment.assetManagerHead,
                      }
                      : {
                        label: "",
                        user: investment.assetManagerHead,
                      }
                  }
                  // sx={{ width: 400 }}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleAssetManagerHeadChange(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Asset Manager Head"
                      size="small"
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="SectorHead"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="SectorHead-id"
                  options={userList}
                  readOnly={page === "view"}
                  value={
                    investment.sectorHead != null
                      ? {
                        label:
                          investment.sectorHead.firstName +
                          " " +
                          investment.sectorHead.lastName,
                        user: investment.sectorHead,
                      }
                      : {
                        label: "",
                        user: investment.sectorHead,
                      }
                  }
                  // sx={{ width: 400 }}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleSectorHeadChange(value);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Sector Head" size="small" />
                  )}
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="Portfolio"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="Portfolio-id"
                  options={userList}
                  readOnly={page === "view"}
                  value={
                    investment.portfolioManager != null
                      ? {
                        label:
                          investment.portfolioManager.firstName +
                          " " +
                          investment.portfolioManager.lastName,
                        user: investment.portfolioManager,
                      }
                      : {
                        label: "",
                        user: investment.portfolioManager,
                      }
                  }
                  // sx={{ width: 400 }}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handlePortfilioManagerChange(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Portfolio Manager"
                      size="small"
                    />
                  )}
                />
              )}
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <Controller
              name="city"
              control={control}
              render={({ field }) => (
                <TextField
                  label="City"
                  InputProps={{
                    readOnly: page === "view",
                  }}
                  value={investment.city}
                  onChange={(e) => handleCityChange(e.target.value)}
                  defaultValue=""
                  variant="outlined"
                  fullWidth
                  size="small"
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="state"
              control={control}
              render={({ field }) => (
                <TextField
                  label="State"
                  InputProps={{
                    readOnly: page === "view",
                  }}
                  value={investment.state}
                  onChange={(e) => handleStateChange(e.target.value)}
                  defaultValue=""
                  variant="outlined"
                  fullWidth
                  size="small"
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="Country"
              control={control}
              render={({ field }) => (
                <TextField
                  label="Country"
                  InputProps={{
                    readOnly: page === "view",
                  }}
                  value={investment.state}
                  onChange={(e) => handleCountryChange(e.target.value)}
                  defaultValue=""
                  variant="outlined"
                  fullWidth
                  size="small"
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <FormControl
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <FormLabel id="row-radio-buttons-group-label">
                Has Debt Liability <span style={{color:'red'}}>*</span>
              </FormLabel>
              <RadioGroup
                row
                style={{ marginLeft: "25px" }}
                aria-readonly={page === "view"}
                aria-labelledby="row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={investment.hasDebtLiability === true ? "Yes" : "No"}
                onChange={handleHasDebtLiabilityChange}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="InvestmentStatus"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="Investment-status"
                  readOnly={page === "view"}
                  options={investmentStatusList}
                  value={investment.status}
                  // sx={{ width: 400 }}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleInvestmentStatusChange(value != null ? value : "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Investment Status"
                      size="small"
                      error={
                        isSubmit &&
                        (investment.status === null || investment.status === "")
                      }
                      required
                      InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="AssetPortfolioManager"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="AssetAssetPortfolioManager-id"
                  options={userList}
                  readOnly={page === "view"}
                  value={
                    investment.asstPortfolioManager != null
                      ? {
                        label:
                          investment.asstPortfolioManager.firstName +
                          " " +
                          investment.asstPortfolioManager.lastName,
                        user: investment.asstPortfolioManager,
                      }
                      : {
                        label: "",
                        user: investment.asstPortfolioManager,
                      }
                  }
                  // sx={{ width: 400 }}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleAssetPortfilioManagerChange(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Asset Portfolio Manager"
                      size="small"
                    />
                  )}
                />
              )}
            />
          </Grid>
        </Grid >
      </Box >
      {
        investment.investmentType != "Mortgage" && (
          <>
            <Divider className="divider-line"></Divider>
            <Box
              sx={{ width: "100%", typography: "body1" }}
              className="accordion-wrap"
            >
              <Accordion defaultExpanded>
                <AccordionSummary
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                >
                  <Typography>Appraisal Value</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <InvestmentAppraisalValuesForm
                    isDebtLiability={investment.hasDebtLiability ? "Yes" : "No"}
                    page={page}
                  />
                </AccordionDetails>
              </Accordion>
              <Accordion defaultExpanded>
                <AccordionSummary
                  aria-controls="panel2d-content"
                  id="panel2d-header"
                >
                  <Typography>Asset Values</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <InvestmentAssetValuesTableForm
                    submit={isSubmit}
                    page={page}
                  // validators={validators}
                  // setValidators={setValidators}
                  />
                </AccordionDetails>
              </Accordion>
            </Box>
          </>
        )
      }
      < Box sx={{ padding: "15px 2px" }}>
        <Grid item xs={12} sm={12}>
          {page != "view" && (
            <Button sx={{textTransform:"none"}}
              disabled={isError.isError || isSuccess.isSuccess}
              variant="contained"
              size="medium"
              color="success"
              onClick={submitInvestment}
            >
              Submit
            </Button>
          )}
          {page === "view" && (
            <Button sx={{textTransform:"none"}}
              variant="contained"
              size="medium"
              color="success"
              onClick={() => navigate("/investmentmaster/edit/" + invId)}
            >
              Edit
            </Button>
          )}
          <Button 
            variant="outlined"
            size="medium"
            color="error"
            sx={{ ml: 2 }}
            onClick={() => navigate("/investmentmaster/list")}
          >
            Cancel
          </Button>
        </Grid>
      </Box >
    </div >
  );
};
